/* eslint-env browser */
/* eslint-disable */
if (!Object.entries) {
  Object.entries = obj => {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i);

    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
}
/* eslint-enable */

const Map = require("es6-map");
const DEV = window.promo.__env === "beta";

const userFrontEnd = Object.freeze({
  "bwin.com": "bz",
  "bwin.be": "bb",
  "bwin.es": "be",
  "bwin.it": "bi",
  "sh.bwin.de": "sh",
  "premium.com": "pr",
  "10premium.com": "pr",
  "premium39.com": "pr",
  "bwin.dk": "bd",
  "bwin.gr": "br",
  "bwin.fr": "bf",
  "partycasino.com": "pp",
  "partypremium.com": "pa",
  default: "nolabel"
});

const userFrontEndMap = new Map(Object.entries(userFrontEnd));

const userContextDesktop =
  window.bwin.config == null ? null : window.bwin.config.promoConfig;
const userContextMobile =
  window.clientConfig == null ? null : window.clientConfig.promoConfig;
const userInfoDesktop =
  window.bwin.config == null ? null : window.bwin.config.userInfo;
const userInfoMobile = window.clientConfig;

const userContext = () => {
  if (userContextDesktop) return userContextDesktop;
  if (userContextMobile) return userContextMobile;
  return {};
};

const userInfoContext = () => {
  if (userInfoDesktop) return userInfoDesktop;
  if (userInfoMobile) {
    return {
      // Sso: userInfoMobile.m2ClaimsConfig["http://api.bwin.com/v3/user/ssotoken"]
      Sso: userInfoMobile.vnClaims["http://api.bwin.com/v3/user/ssotoken"]
    };
  }
  return {};
};

const userVars = Object.freeze({
  ...userContext(),
  ...userInfoContext(),
  isNew: userContext.isKnown === false
});

/* eslint-disable no-underscore-dangle */
const scLangCode = () => {
  return window.__region === undefined
    ? window.promo.lang
    : `${window.promo.lang}_${window.__region}`;
};
/* eslint-enable no-underscore-dangle */

const sitecoreVars = Object.freeze({
  lang: window.promo.lang,
  portal: window.promo.portal,
  sso: window.promo.userSSO,
  langCode: scLangCode(),
  labelFK: null,
  targetGroupID: window.promo.targetGroupID,
  bonusID: window.promo.bonus_promotion_gid,
  isMobile: window.promo.isMobile === "True",
  isNative: window.promo.isNative === "True"
});

const envConfig = Object.freeze({
  dev: {
    host: "//127.0.0.1:9000/",
    api: "//api-mk.itsfogo.com/api"
  },
  prod: {
    host: "//mkp.itsfogo.com/sites/pc/promo/coin-flip/",
    api: "//api-mk.itsfogo.com/api"
  }
});

const getCtaUrl = (state, data) => {
  if (state.isNative === true) {
    return data.cta_url_native;
  } else if (state.isMobile === true) {
    return data.cta_url_mobile;
  } else {
    return data.cta_url_desktop;
  }
};

const games = {
  bar_x_megaways: {
    desktop:'blueprintbarxsafecrackermw',
    mobile: 'blueprintbarxsafecrackermw',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/blueprintbarxsafecrackermw.jpg?q=90&w=200'
   },
   netentbutterflystaxx: {
    desktop:'netentbutterflystaxx2',
    mobile: 'netentbutterflystaxx2touch',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/netentbutterflystaxx2.jpg?q=90&w=200'
   },
   tip_top_totem: {
    desktop:'playtechtiptoptotems',
    mobile: 'playtechtiptoptotems',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/playtechtiptoptotems.jpg?q=90&w=200'
   },
   book_of_horus: {
    desktop:'ivybookofhorus',
    mobile: 'ivybookofhorus',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/ivybookofhorus.jpg?q=90&w=200'
   },
   wild_robo_factory: {
    desktop:'yggwildrobofactory',
    mobile: 'yggwildrobofactory',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/yggwildrobofactory.jpg?q=90&w=200'
   },
   temple_of_nudges: {
    desktop:'netenttempleofnudges',
    mobile: 'netenttempleofnudgestouch',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/netenttempleofnudges.jpg?q=90&w=200'
   },
   return_of_kong_megaways: {
    desktop:'blueprintreturnofkongmw',
    mobile: 'blueprintreturnofkongmw',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/blueprintreturnofkongmw.jpg?q=90&w=200'
   },
   narcos: {
    desktop:'netentnarcos',
    mobile: 'netentnarcostouch',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/netentnarcos.jpg?q=90&w=200'
   },
   gladiator_jackpot: {
    desktop:'playtechgladiatorjp1',
    mobile: 'playtechgladiatorjp1',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/playtechgladiatorjp1.jpg?q=90&w=200'
   },
   spin_and_win: {
    desktop:'ivyspinandwin',
    mobile: 'ivyspinandwin',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/ivyspinandwin.jpg?q=90&w=200'
   },
   wilhelm_tell: {
    desktop:'yggwilhelmtell',
    mobile: 'yggwilhelmtell',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/yggwilhelmtell.jpg?q=90&w=200'
   },
   dead_or_alive_2: {
    desktop:'netentdeadoralive2',
    mobile: 'netentdeadoralive2touch',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/netentdeadoralive2.jpg?q=90&w=200'
   },
   fishin_frenzy_megaways: {
    desktop:'blueprintfishingfrenzym',
    mobile: 'blueprintfishingfrenzym',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/blueprintfishingfrenzym.jpg?q=90&w=200'
   },
   grandspin: {
    desktop:'netentgrandspinn',
    mobile: 'netentgrandspinntouch',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/netentgrandspinn.jpg?q=90&w=200'
   },
   jungle_giants: {
    desktop:'playtechjunglegiants',
    mobile: 'playtechjunglegiants',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/playtechjunglegiants.jpg?q=90&w=200'
   },
   the_win_genie: {
    desktop:'ivythewingenie',
    mobile: 'ivythewingenie',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/ivythewingenie.jpg?q=90&w=200'
   },
   the_win_ginie: {
    desktop:'ivythewingenie',
    mobile: 'ivythewingenie',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/ivythewingenie.jpg?q=90&w=200'
   },
   vikings_go_berzerk: {
    desktop:'yggvikingsgoberzerk',
    mobile: 'yggvikingsgoberzerk',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/yggvikingsgoberzerk.jpg?q=90&w=200'
   },
   turn_your_fortune: {
    desktop:'netentturnyourfortune',
    mobile: 'netentturnyourfortunetouch',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/netentturnyourfortune.jpg?q=90&w=200'
   },
   beavies_and_butthead: {
    desktop:'blueprintbeavisandbutthead',
    mobile: 'blueprintbeavisandbutthead',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/blueprintbeavisandbutthead.jpg?q=90&w=200'
   },
   white_king_ii: {
    desktop:'playtechwhiteking2',
    mobile: 'playtechwhiteking2',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/playtechwhiteking2.jpg?q=90&w=200'
   },
   dazzling_sun: {
    desktop:'ivydazzlingsun',
    mobile: 'ivydazzlingsun',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/ivydazzlingsun.jpg?q=90&w=200'
   },
   valley_of_the_gods: {
    desktop:'yggvalleyofthegods',
    mobile: 'yggvalleyofthegods',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/yggvalleyofthegods.jpg?q=90&w=200'
   },
   gonzo_s_quest: {
    desktop:'netentgonzosquest',
    mobile: 'netenteldoradotouch',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/netentgonzosquest.jpg?q=90&w=200'
   },
   wild_worlds: {
    desktop:'netentwildworlds',
    mobile: 'netentwildworldstouch',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/netentwildworlds.jpg?q=90&w=200'
   },
   loot_en_khamun_and_the_dead_sea_scroll: {
    desktop:'ivylootenkhamunanddeadseascrolls',
    mobile: 'ivylootenkhamunanddeadseascrolls',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/ivylootenkhamunanddeadseascrolls.jpg?q=90&w=200'
   },
   the_mercy_of_the_gods: {
    desktop:'netentmercyofthegods',
    mobile: 'netentmercyofthegodstouch',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/netentmercyofthegods.jpg?q=90&w=200'
   },
   mega_fortune_wheel: {
    desktop:'MegaFortuneWheel',
    mobile: 'MegaFortuneWheel',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/MegaFortuneWheel.jpg?q=90&w=200'
   },
   ways_of_the_phoenix: {
    desktop:'playtechwaysofthephoenix',
    mobile: 'playtechwaysofthephoenix',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/playtechwaysofthephoenix.jpg?q=90&w=200'
   },
   quantum_roulette: {
    desktop:'playtechlivequantumroulette',
    mobile: 'playtechlivequantumroulette',
    image:
    'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/playtechlivequantumroulette.jpg?q=90&w=200'
   }   
};

const helpers = Object.freeze({
  user: userVars,
  sitecore: sitecoreVars,
  config: DEV ? envConfig.dev : envConfig.prod,
  feGet: userFrontEndMap,
  getCtaUrl: getCtaUrl,
  games: games
});

export default helpers;



// WEBPACK FOOTER //
// ./app/js/helpers/globals.js